export default "__VITE_ASSET__BWrcN8gY__"